import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const hash = window.location.hash || "";
    if (hash.includes("session_id=")) {
      const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
      if (sessionId) {
        api.post("/auth/google/session", { session_id: sessionId })
          .then((r) => {
            localStorage.setItem("rw_token", r.data.token);
            setUser(r.data.user);
          })
          .catch(() => {})
          .finally(() => {
            window.history.replaceState(null, "", window.location.pathname + window.location.search);
            setLoading(false);
          });
        return;
      }
    }
    const token = localStorage.getItem("rw_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem("rw_token");
    }).finally(() => setLoading(false));
  }, []);

  const loginWithToken = (token, u) => {
    localStorage.setItem("rw_token", token);
    setUser(u);
  };
  const logout = () => {
    localStorage.removeItem("rw_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loginWithToken, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}
